import React, { useCallback, useContext, useEffect, useState } from "react";
import { t } from "i18next";
import { Checkbox, DefaultButton, PrimaryButton, TextField, ChoiceGroup, Dropdown, TooltipHost } from "@fluentui/react";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
import { useSearchParams } from "react-router-dom";
import ClearIcon from "../../../../components/SVGComponents/ClearIcon";
import "./FirmAccessSection.css";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import themeContext from "../../../../context/theme/ThemeContext";
import { getEnv } from '../../../../helpers/EnvHelper';



const FirmAccessSection = (props) => {
  const [searchParams] = useSearchParams();
  const { roles, authenticated, loadByUsername, userId } =
    useContext(userContext);
  const {themeName}=useContext(themeContext);
    const dropDownStyle = {
      dropdown: {
        width: "100%"
      },
      dropdownItemSelected: {
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: "600",
      },
      dropdownItemsWrapper: {
        maxHeight: "300px",
        overflowY: 'auto',
        colorScheme:`${themeName==='light'?'none':'inherit'}`  
      },
      dropdownItem: {
        fontSize: "12px",
        lineHeight: "18px",
        fontWeight: "600",
        color: "white"
      },
    };

  const [filteredList, setFilteredList] = new useState(((k) =>{
    if(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN){
      if(!k.some(obj => obj.id === Number(props.firmId))){
        k.unshift({
          id:Number(props.firmId),
          name:props.firmName
        });
      }
    }
    return k;
  })(props.firmList));


  const filterBySearch = (event) => {

    const query = event.target.value;
    var updatedList = [...props.firmList];
    updatedList = updatedList.filter((item) => {
      return item.name.toLowerCase().indexOf(query.toLowerCase()) !== -1 || props.checkFirmNew.has(item.id);
    });
    setFilteredList(updatedList);
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  // useEffect(()=>{
  //   if(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN){
  //     if(!filteredList.some(obj => obj.id === Number(props.firmId))){
  //       filteredList.unshift({
  //         id:Number(props.firmId),
  //         name:props.firmName
  //       });
  //     }
  //   }
  // },[filteredList])

  const getModalityNames = (modalityIds) =>{
    let modalityNames = [];
    props.modalityList.filter(m=>modalityIds.includes(m.id)).map((modality) => {
      modalityNames.push(modality.name);
    });
    return modalityNames.join(', ');
  }
  
  let modalityList = [];
  props.modalityList.map((modality) => {
    modalityList.push({
      key: modality.id,
      text: modality.name,
    });
  });

  return (
    <>
      {/* FIRM LIST TO BE SHOWN FOR SUPERVISOR and RADIOLOGIST ROLE */}
      {props.firmList?.length > 0 && (props.state.action == ACTIONS.ADD || props.state.action == ACTIONS.EDIT) &&
        ((roles[0] === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST)
          || (props.userType === USERTYPES.SUPERVISOR)|| (props.userType === USERTYPES.FIRMDOCTOR)|| (props.userType === USERTYPES.FIRMTECHNICIAN))
        && (
          <div className="tab-section">
            <div className="ms-Grid" dir="ltr">
              
            {!(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) &&
              <div className="ms-Grid-row single-line-form-field" style={{ marginBottom: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl9">
                  <p className="single-line-form-field-key">For Firm {props.firmName}</p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3 single-line-form-field-value">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                      <Dropdown
                        styles={dropDownStyle}
                        placeholder="Select Modality"
                        defaultSelectedKeys={props.selectedModalityForFirm}
                        options={modalityList}
                        multiSelect
                        onChange={(e, selection) => {
                          props.handleModalitySelectionForFirm(e, selection.key)
                        }}
                      // errorMessage={props.errors.modalityIdList}
                      />
                    </div>
                    <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => props.handleClearButtonForFirm()} style={{ paddingLeft: "5px" }}>
                      <CustomToolTipHost content="Clear">
                        <ClearIcon></ClearIcon>
                      </CustomToolTipHost>
                    </div>
                  </div>
                </div>
              </div>
            }
                  
              <div className="ms-Grid-row">
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                  <p className="form-field-key" style={{ marginBottom: "20px", fontWeight: "bold" }}>
                    {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === true || getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true"
                      ? t("user.access-to-the-selected-hospitals") : t("user.access-to-the-selected-firms")}
                  </p>
                </div>
                <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl3">
                  <TextField placeholder="Search" onChange={filterBySearch} />
                </div>
              </div>

              <div className="ms-Grid-row">
                <div className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                  <Checkbox
                    label="Select All"
                    onChange={props.handleAllCheckboxClick}
                    id="all"
                    checked={props.checkAllFirm==true}
                  />
                </div>
              </div>
              <div className="ms-Grid-row">
                {filteredList.map((firm,index) => {
                  return (
                    <div key={index} className="checkbox-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl4">
                      <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10" style={{ display: "block",whiteSpace: "nowrap",overflow: "hidden",textOverflow: "ellipsis"}}>
                          <Checkbox
                            key={firm.id}
                            label={firm.name}
                            name={firm.name}
                            onChange={(e, isChecked) => props.handleCheckBoxClick(firm.id, isChecked, 0)}
                            //checked={props.checkFirm.includes(firm.id)}
                            checked={props.checkFirmNew.has(firm.id)}
                          />
                      </div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                          <Dropdown

                            styles={dropDownStyle}
                            placeholder="Select Modality"
                            multiSelect
                            defaultSelectedKeys={props.checkFirmNew.get(firm.id) || []}
                            options={modalityList}
                            disabled={!props.checkFirmNew.has(firm.id)}
                            onChange={(e, selection) => props.handleCheckBoxClick(firm.id, true, selection.key)}
                          // errorMessage={props.errors.modalityIdList}
                          />
                        </div>
                        <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={()=> props.handleClearButton(firm.id)} style={{ paddingLeft: "5px"}}>
                          <CustomToolTipHost content="Clear" id={"tooltip_" + firm.id} >
                            <ClearIcon></ClearIcon>
                          </CustomToolTipHost>
                        </div>
                        {/* <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2">
                          <p>select all</p>
                        </div> */}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      {props.state.action == ACTIONS.VIEW && (
        <div className="tab-section">
          <div className="ms-Grid" dir="ltr">
            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12">
                <p
                  className="form-field-key form-heading"
                  style={{ marginBottom: "20px", fontWeight: "bold" }}
                >
                  {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === true || getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true"
                    ? "User has access to the following hospitals"
                    : "User has access to the following firms"}
                </p>
                <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                    {!(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) &&
                      <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12" style={{ display: 'flex', alignItems: 'center' }}>
                        <p style={{ flex: 1, marginTop: '10px', marginRight: '10px', marginBottom: '10px', marginLeft: '0px' }}>{props.firmName}</p>
                        <span className="firm-access-modality-names">
                          <CustomToolTipHost content={getModalityNames(props.selectedModalityForFirm)} id={"tooltip_"}>
                            {getModalityNames(props.selectedModalityForFirm)}
                          </CustomToolTipHost>
                        </span>
                      </div>
                    }
                       
                      {filteredList.map((firm) => {
                        return (
                          <>

                            {!!props.checkFirmNew.has(firm.id) &&
                              <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl12" style={{ display: 'flex', alignItems: 'center' }}>
                              <p style={{ flex: 1, marginTop: '10px', marginBottom: '10px', marginRight: '10px', marginLeft: '0px' }}>
                                {firm.name}
                              </p>
                              <div className="firm-access-modality-names">
                                <CustomToolTipHost content={getModalityNames(props.checkFirmNew.get(firm.id))} id={"tooltip_"}>
                                  {getModalityNames(props.checkFirmNew.get(firm.id))}
                                </CustomToolTipHost>
                              </div>
                            </div>

                            }

                          </>
                        );
                      })}
                    </div>
                  {(Array.from(props.checkFirmNew).filter((key, value) => key != searchParams.get("firmId")).size===0 || props.firmList.length===0 ||
                    props.firmList.filter((firm) => props.checkFirmNew.has(firm.id)).length===0) && !(props.userType === USERTYPES.FIRMDOCTOR || props.userType === USERTYPES.FIRMTECHNICIAN) && 
                    <div className="ms-Grid-row">
                      <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                        <p className="form-field-key" style={{ marginBottom: "20px"}}>
                        {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === true || getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true"
                                ? t("user.no-hospital-available") : t("user.no-firm-available")}
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      )
      }
      {props.firmList?.length == 0 && (props.state.action == ACTIONS.ADD || props.state.action == ACTIONS.EDIT) &&
        ((roles[0] === USERTYPES.FIRMADMIN && props.userType === USERTYPES.RADIOLOGIST)
          || (props.userType === USERTYPES.SUPERVISOR)) &&
        <div className="tab-section">
          <div className="ms-Grid" dir="ltr">

          <div className="ms-Grid-row single-line-form-field" style={{ marginBottom: "20px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl9">
                  <p className="single-line-form-field-key">For Firm {props.firmName}</p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl3 single-line-form-field-value">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div className="ms-sm12 ms-md8 ms-lg6 ms-xl10">
                      <Dropdown
                        styles={dropDownStyle}
                        placeholder="Select Modality"
                        defaultSelectedKeys={props.selectedModalityForFirm}
                        options={modalityList}
                        multiSelect
                        onChange={(e, selection) => {
                          props.handleModalitySelectionForFirm(e, selection.key)
                        }}
                      // errorMessage={props.errors.modalityIdList}
                      />
                    </div>
                    <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" onClick={() => props.handleClearButtonForFirm()} style={{ paddingLeft: "5px" }}>
                      <TooltipHost content="Clear">
                        <ClearIcon></ClearIcon>
                      </TooltipHost>
                    </div>
                  </div>
                </div>
              </div>

            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                <p className="form-field-key" style={{ marginBottom: "20px", fontWeight: "bold" }}>
                  {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === true || getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true"
                    ? t("user.access-to-the-selected-hospitals") : t("user.access-to-the-selected-firms")}
                </p>
              </div>
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl3">
                <TextField placeholder="Search" onChange={filterBySearch} />
              </div>
            </div>

            <div className="ms-Grid-row">
              <div className="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl9">
                <p className="form-field-key" style={{ marginBottom: "20px"}}>
                {getEnv("REACT_APP_ENTERPRISE_PLATFORM") === true || getEnv("REACT_APP_ENTERPRISE_PLATFORM") == "true"
                        ? t("user.no-hospital-available") : t("user.no-firm-available")}
                </p>
              </div>
            </div>
          </div>
        </div>}
    </>
  );
}

export default FirmAccessSection